import cx from 'classnames';
import { useRef } from 'react';

import { useAnimation } from '../../hooks/useAnimation';

import styles from '../../styles/modules/tasks/Tasks.module.scss';
import awardStyles from '../../styles/modules/tasks/TasksAward.module.scss';

import Icon from '../icon/Icon';
import TaskButton from './TaskButton';

import { EVENT_AWARD_TYPES, TASKS_CLASSES } from '../../utils/constants';

const tasks = [
	{
		level: 59,
		title: 'Тяжелая ноша ',
		class: 'disabled',
		point_cost: 1878,
		description: '',
		icon: '59.webp',
		button: [],
		award: {
			type: 'COINS',
			points: 250,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
		},
	},
	{
		level: 60,
		title: 'Один шаг до ножа',
		class: 'special-yellow disabled',
		point_cost: 2577,
		description: '',
		icon: '60.png',
		button: [],
		award: {
			type: 'CASE',
			points: 450,
			prizes: 1,
			icon: '/assets/img/cases/c46f979a2240192fcc84e9b3f3998b5c4f56.png',
			name: 'podarochnyy-nozh',
			title: 'Подарочный нож',
		},
	},
	{
		level: 1,
		title: 'Игро-тестер',
		class: 'available',
		point_cost: 5,
		description: 'Cыграть 1 раз в бесплатную мини-игру ',
		icon: '1.webp',
		button: {
			icon: 'gift_open',
			href: '/event#battle',
			target: '_self',
		},
		award: {
			type: 'COINS',
			points: 10,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '250',
		},
		weight_cur: 0,
		weight_max: 1,
		pointCur: 0,
	},
	{
		level: 2,
		title: 'Твой первый кейс',
		class: 'disabled',
		point_cost: 15,
		description: '',
		icon: '2.webp',
		button: [],
		award: {
			type: 'COINS',
			points: 5,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '50',
		},
	},
	{
		level: 3,
		title: 'Твое новое имя',
		class: 'disabled',
		point_cost: 15,
		description: '',
		icon: '3.webp',
		button: [],
		award: {
			type: 'COINS',
			points: 5,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '50',
		},
	},
];

const Tasks = () => {
	const userLevel = 1;

	const { COINS } = EVENT_AWARD_TYPES;
	const { CHECKED, AVAILABLE } = TASKS_CLASSES;

	const knifeRef = useRef(null);
	const glovesRef = useRef(null);

	useAnimation({
		ref: knifeRef,
		name: 'knife',
	});

	useAnimation({
		ref: glovesRef,
		name: 'gloves',
	});

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={cx(styles.award, styles.left)}>
					<div ref={glovesRef} className={cx(styles.animation, styles.gloves)} />

					<div className={styles.awardTitle}>
						<p className={styles.awardTitleTop}>награда</p>
						<p>
							за <span>15 уровней</span>
						</p>
					</div>
				</div>
				<div className={styles.missions}>
					<p className={styles.missionsTitle}>Или выполняй задания Battle Pass</p>

					<div className={styles['missions-list']}>
						{tasks.map(
							(
								{
									award: { title: awardTitle, type, amount, points },
									weight_cur: currentWeight,
									weight_max: maxWeight,
									class: taskClassName,
									description,
									level,
									title,
									icon,
								},
								idx,
							) => {
								const iconName = taskClassName.includes(CHECKED) ? 'check' : 'lock';

								const classes = taskClassName
									.split(' ')
									.map((cls) => styles[cls])
									.filter(Boolean)
									.join(' ');

								const isActive = userLevel === level;

								const width = maxWeight > 1 ? (currentWeight * 100) / maxWeight : 0;
								const overlay = 100 - width;
								const completed = overlay <= 1;

								const key = `${level}-${title}-${idx}`;

								return (
									<div
										className={cx(`${styles.task} ${classes}`, {
											[styles.full]: isActive,
										})}
										data-active='false'
										key={key}
									>
										{isActive ? (
											<div
												className={cx(`${styles['missions-item']} ${classes}`, {
													[styles.full]: isActive,
												})}
												data-active='true'
											>
												<div className={styles.missionContent}>
													<div className={styles.itemIcon}>
														<Icon name={iconName} />
													</div>

													<div className={cx(styles['missions-icon'], styles['missions-lvl'])}>
														<span>{level}</span>
													</div>

													<div className={styles['missions-headling']}>
														<div className={styles['missions-title']}>{title}</div>

														<p
															className={awardStyles['mission-description']}
															dangerouslySetInnerHTML={{ __html: description }}
														/>
													</div>

													{maxWeight && (
														<div className={cx(awardStyles.progressbar, styles.progressbar)}>
															<p>
																<span className={awardStyles.current}>{currentWeight}</span>
																<span className={awardStyles.total}> из {maxWeight}</span>
															</p>
															<div className={awardStyles.progress}>
																{!!width && (
																	<span
																		className={cx(awardStyles.fill, {
																			[awardStyles.visible]: completed,
																		})}
																		style={{ width: `${width}%` }}
																	/>
																)}
															</div>
														</div>
													)}

													<TaskButton className={cx(awardStyles.button, styles.missionButton)} />
												</div>

												<div className={styles.missionAward}>
													<div className={styles.missionAwardTitle}>Награды</div>
													<div className={styles.missionAwardImage}>
														<img
															src={require('../../assets/images/cases/award.webp')}
															alt=''
															loading='lazy'
														/>
													</div>
													<div className={styles.missionAwardHeadling}>{awardTitle}</div>
													<div className={styles.missionAwardInfo}>
														<span />
														<p>
															{level} → {level + 1} LVL
														</p>
														<div className={styles.missionAwardXP}>
															<Icon name='xp' />
															<p>{points}</p>
														</div>
													</div>
												</div>
											</div>
										) : (
											<div
												className={cx(`${styles['missions-item']} ${classes}`, {
													[styles.full]: isActive,
												})}
												data-active='false'
											>
												<div className={styles.itemIcon}>
													<Icon name={iconName} />
												</div>

												<div className={cx(styles['missions-icon'], styles['missions-lvl'])}>
													<span>{level}</span>
												</div>

												<div className={styles.lockIcon}>
													<Icon name={`transparent-${iconName}`} className={styles[iconName]} />
												</div>

												<div className={styles['missions-image']}>
													<img
														src={require(`../../assets/images/cases/${icon}`)}
														alt=''
														loading='lazy'
													/>
												</div>

												<div className={styles['missions-title']}>{title}</div>

												<div className={styles['missions-subtitle']}>
													<span>Награда: </span>
													{type === COINS ? (
														<p>
															<span>ЭПИК КОИНЫ</span> <span>{amount}</span> <Icon name='coins' />
														</p>
													) : (
														<p>{awardTitle}</p>
													)}
												</div>
											</div>
										)}
									</div>
								);
							},
						)}
					</div>
				</div>

				<div className={cx(styles.award, styles.right)}>
					<div ref={knifeRef} className={cx(styles.animation, styles.knife)} />

					<div className={styles.awardTitle}>
						<p className={styles.awardTitleTop}>награда</p>
						<p>
							за <span>60 уровней</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Tasks;
